import useSWR from "swr";
import apiClient from "../../../apiClient";
import { SelectOption, Team } from "../../../globals/interfaces";
import useUser from "../../../customHooks/useUser";
import Select from "../../../components/Select";
import { Label } from "reactstrap";
import styled from "styled-components";
import ActionIcon, { IconTypes } from "../../../components/custom/ActionIcon";
import { Fragment, useState } from "react";
import ModalManageTeam from "./ModalManageTeam";
import { notify } from "../../../utils";
import { useRecoilState, useRecoilValue } from "recoil";
import { selectedTeamIdState } from "./atoms";
import useTeams, { CreateUpdateItem, DeleteTeam } from "./useTeams";
import Icon from "../../../components/custom/Icon";

export type CreateOrUpdateTeam = 'CREATE' | 'UPDATE';

export default function SelectTeam({
    teams,
    selectedTeamId,
    setSelectedTeamId,
    selectedTeam,
    createUpdateTeam,
    deleteTeam,
    setModalMembers,
    exportData
}: {
    teams: Array<Team>;
    selectedTeamId: number | undefined;
    setSelectedTeamId: React.Dispatch<React.SetStateAction<number>>;
    selectedTeam: Team | undefined;
    createUpdateTeam: CreateUpdateItem;
    deleteTeam: DeleteTeam;
    setModalMembers: React.Dispatch<React.SetStateAction<boolean>>;
    exportData: () => void;
}) {

    const { user } = useUser();
    const noTeams = teams.length === 0;
    // const { teams, selectedTeam, selectedTeamId, setSelectedTeamId, mutate } = useTeams();

    const selectOptions: Array<SelectOption<number>> = teams.map(item => ({ label: item.name, value: item.id }));
    const [updateTeam, setUpdateTeam] = useState<boolean>(false);
    const [modal, setModal] = useState(false);

    const handleCreateUpdate = (udpateTeam: boolean) => {
        setUpdateTeam(udpateTeam);
        setModal(true);
    }

    const handleCreateUpdateTeam = async (data: Team) => {
        const result = await createUpdateTeam(data, updateTeam);
        if (result) {
            notify(updateTeam ? 'Updated' : 'Created');
            setModal(false);
        }
    }

    const handleDeleteTeam = async () => {
        const result = await deleteTeam(selectedTeamId);
        if (result) {
            setModal(false);
            notify('Deleted');
        }
    }

    return (
        <div>
            <Label className={!selectedTeamId && 'pulse'}>
                Select Group
                {noTeams && <span className={'ml-1 bg-warning'}>No Groups</span>}
            </Label>
            <FlexContainer>
                <Select
                    options={selectOptions}
                    value={selectedTeamId}
                    onChange={option => setSelectedTeamId(Number(option.value))}
                    width={350}
                    disabled={noTeams}
                />
                <ButtonWithText 
                    type={'add'} 
                    onClick={() => handleCreateUpdate(false)}
                    text={'Create New Group'}
                />
                {
                    selectedTeamId && (
                        <Fragment>
                            <ButtonWithText 
                                type={'update'} 
                                onClick={() => handleCreateUpdate(true)}
                                text={'Edit Group Name'}
                            />
                            <FlexContainer className={'mx-3'}>
                                <Icon
                                    className={'fa-duotone fa-solid fa-people-group text-success'}
                                    onClick={() => setModalMembers(true)}
                                    size={36}
                                />
                                <h6>Add Members to Group</h6>
                            </FlexContainer>
                            <ButtonWithText 
                                type={'csv'} 
                                onClick={() => exportData()}
                                text={''}
                            />
                        </Fragment>
                    )
                }
            </FlexContainer>
            <ModalManageTeam
                modal={modal}
                setModal={setModal}
                user={user}
                selectedTeam={selectedTeam}
                updateTeam={updateTeam}
                handleCreateUpdateTeam={handleCreateUpdateTeam}
                handleDeleteTeam={handleDeleteTeam}
            />
        </div>
    );
}

const ButtonWithText = ({
    type,
    onClick,
    text
}: {
    type: IconTypes;
    onClick: () => void;
    text: string;
}) => {
    return (
        <FlexContainer className={'mx-3'}>
            <ActionIcon type={type} onClick={onClick} />
            <h6>{text}</h6>
        </FlexContainer>
    );
}

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;